export default function PricingPage() {
  return (
    <div className="min-h-screen bg-obsidian text-white font-body">
      {/* Header */}
      <header className="border-b border-line bg-surface/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-volt rounded-sm flex items-center justify-center">
              <span className="text-obsidian font-black text-lg">B</span>
            </div>
            <div>
              <h1 className="font-heading text-lg font-black uppercase tracking-tight leading-none">BetModel</h1>
              <p className="text-[10px] text-txt-secondary uppercase tracking-[0.2em]">Sports Analytics</p>
            </div>
          </div>
          <a href="/" className="text-volt text-sm font-bold hover:underline">← Voltar ao site</a>
        </div>
      </header>

      {/* Hero */}
      <div className="max-w-4xl mx-auto px-4 py-16 text-center">
        <p className="text-volt text-xs font-bold uppercase tracking-widest mb-4">Planos e Preços</p>
        <h2 className="font-heading text-4xl font-black uppercase tracking-tight mb-4">
          Análise Desportiva<br />com Inteligência Artificial
        </h2>
        <p className="text-txt-secondary text-lg max-w-2xl mx-auto">
          Probabilidades calculadas por modelos estatísticos avançados para mais de 20 ligas de futebol em todo o mundo.
        </p>
      </div>

      {/* Pricing Cards */}
      <div className="max-w-4xl mx-auto px-4 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Free Plan */}
          <div className="bg-surface border border-line rounded-sm p-8">
            <div className="mb-6">
              <p className="text-txt-secondary text-xs font-bold uppercase tracking-widest mb-2">Plano Gratuito</p>
              <div className="flex items-end gap-2">
                <span className="font-mono text-4xl font-black text-white">$0</span>
                <span className="text-txt-secondary text-sm mb-1">/mês</span>
              </div>
            </div>
            <ul className="space-y-3 mb-8">
              {[
                "✅ Calendário de jogos de 20+ ligas",
                "✅ Probabilidades básicas (1X2)",
                "✅ Dados de golos esperados",
                "✅ Cantos e estatísticas",
                "🔒 Value Bets (Premium)",
                "🔒 Top Tips do dia (Premium)",
                "🔒 Sem anúncios (Premium)",
              ].map((item, i) => (
                <li key={i} className="text-sm text-txt-secondary">{item}</li>
              ))}
            </ul>
            <a href="/" className="block w-full py-3 text-center border border-line rounded-sm text-txt-secondary text-sm font-bold hover:bg-surface-hover transition-colors">
              Começar Grátis
            </a>
          </div>

          {/* Premium Plan */}
          <div className="bg-surface border border-volt rounded-sm p-8 relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-volt text-obsidian text-[10px] font-black uppercase tracking-widest px-2 py-1 rounded-sm">
              Popular
            </div>
            <div className="mb-6">
              <p className="text-volt text-xs font-bold uppercase tracking-widest mb-2">Plano Premium</p>
              <div className="flex items-end gap-2">
                <span className="font-mono text-4xl font-black text-white">$9.99</span>
                <span className="text-txt-secondary text-sm mb-1">/mês</span>
              </div>
              <div className="mt-2 inline-block bg-volt/10 border border-volt/30 rounded-sm px-3 py-1">
                <span className="text-volt text-xs font-bold">🎉 Primeiro mês por $4.99</span>
              </div>
            </div>
            <ul className="space-y-3 mb-8">
              {[
                "✅ Tudo do plano gratuito",
                "✅ Value Bets com edge calculado",
                "✅ Top Tips do dia filtradas por IA",
                "✅ Previsões completas sem anúncios",
                "✅ Stake sugerido por Kelly Criterion",
                "✅ Acesso web + app mobile",
                "✅ Suporte prioritário",
              ].map((item, i) => (
                <li key={i} className="text-sm text-white">{item}</li>
              ))}
            </ul>
            <button className="block w-full py-3 text-center bg-volt text-obsidian rounded-sm text-sm font-black uppercase tracking-wider hover:bg-volt/90 transition-colors">
              Assinar Premium
            </button>
            <p className="text-txt-secondary text-[10px] text-center mt-3">Cancela a qualquer momento · Garantia de 14 dias</p>
          </div>
        </div>

        {/* Features */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: "🤖", title: "Modelo V9.0", desc: "Dynamic Matchup com EMA, Attack/Defense ratio, Pressure Corners e Red Flag detection." },
            { icon: "📊", title: "20+ Ligas", desc: "Premier League, La Liga, Bundesliga, Serie A, Primeira Liga, Champions League e muito mais." },
            { icon: "🎯", title: "Value Bets", desc: "Identifica apostas com edge positivo usando probabilidades implícitas vs odds de mercado." },
          ].map((f, i) => (
            <div key={i} className="bg-surface border border-line rounded-sm p-6 text-center">
              <div className="text-3xl mb-3">{f.icon}</div>
              <h3 className="font-heading text-sm font-bold uppercase tracking-widest mb-2">{f.title}</h3>
              <p className="text-txt-secondary text-sm">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Legal */}
        <div className="mt-12 text-center text-txt-secondary text-xs space-y-1">
          <p>BetModel é uma plataforma de análise estatística. Não realizamos apostas nem aceitamos fundos.</p>
          <p>As previsões são baseadas em modelos matemáticos e não garantem resultados.</p>
          <div className="flex justify-center gap-4 mt-3">
            <a href="/terms" className="hover:text-white">Termos</a>
            <a href="/privacy" className="hover:text-white">Privacidade</a>
            <a href="/refund" className="hover:text-white">Reembolso</a>
          </div>
        </div>
      </div>
    </div>
  );
}
